import { useCallback, useEffect, useState } from "react";
import DatepickerContainer from "../Datepicker/DatepickerContainer";
import api from "../../services/api";
import { useMassBalancePage } from "../../contexts/MassBalancePageContext";
 
function DatepickerMassBalance() {
 
    const [datesList, setDatesList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [hasLoaded, setHasLoaded] = useState(false);
    const { selectedDate, setSelectedDate } = useMassBalancePage();
 
    const fetchMassBalanceDates = useCallback(async () => {
        setLoading(true);
        setError(null);
 
        try {
            const response = await api.get("/mass-balance-post-dates");
            const receivedDates = Array.isArray(response.data) ? response.data : [];

            setDatesList(receivedDates);
            setSelectedDate(receivedDates[receivedDates.length - 1] || null);
        } catch (requestError) {
            console.error("Erro ao buscar datas do Mass Balance:", requestError);
            setDatesList([]);
            setError(requestError?.response?.data?.message || "Não foi possível carregar as datas do Mass Balance.");
        } finally {
            setLoading(false);
            setHasLoaded(true);
        }
    }, [setSelectedDate]);

    useEffect(() => {
        fetchMassBalanceDates();
    }, [fetchMassBalanceDates]);
 
    return (
        <div className="flex flex-col gap-1">
            <DatepickerContainer
                selectedValue={selectedDate}
                onChange={setSelectedDate}
                datesList={datesList}
                format="DD/MM/YYYY"
                disabled={hasLoaded && !error && datesList.length === 0}
            />
 
            {loading && <span className="text-xs text-gray-500">Carregando datas...</span>}
            {error && <span className="text-xs text-red-600">{error}</span>}
            {hasLoaded && !loading && !error && datesList.length === 0 && (
                <span className="text-xs text-gray-500">Nenhuma data disponível.</span>
            )}
        </div>
    );
}
 
export default DatepickerMassBalance;
